var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormInput',{attrs:{"label":"Chat ID","value":_vm.data.chat_id,"hint":"Private Channel / Group ID"},on:{"update":function($event){_vm.data.chat_id=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }